// The server keeps at most 1440 px; the headroom keeps its resize and face-centered icon unchanged
export const MAX_UPLOAD_DIMENSION = 2048;
export const UPLOAD_JPEG_QUALITY = 0.8;
